import PropTypes from "prop-types";
import React from "react";

import { Badge, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

export const LoyaltyTierBadge = (props) => {
  const { tier } = props;
  const styleTypes = {
    A_LIST: "tier-a-list",
    A_LIST_PREFERRED: "tier-a-list-preferred",
    PENDING: "tier-pending",
  };
  const styleType = styleTypes[tier];

  return (
    styleType && (
      <Badge height="xsmall" styleType={`${styleType}-background`} type="flag">
        <Text bold color={`${styleType}-text`}>
          {i18n(`LoyaltyTierBadge__${tier}`)}
        </Text>
      </Badge>
    )
  );
};

LoyaltyTierBadge.propTypes = {
  /** The loyalty tier level to display. */
  tier: PropTypes.oneOf(["A_LIST", "A_LIST_PREFERRED", "PENDING"]).isRequired,
};
